import { encodePeriodValue } from '@components'

import { useMemo } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useGlobalFiscalYear } from '../../../contexts/globalFiscalYearContext'
import { useQueryParams } from '../../../hooks/useQueryParams'
import { getPeriodValueFromFiscalYear } from '../../../utils/getPeriodValueFromFiscalYear'
import { SalesReportDateSelection } from '../enums/salesReportDateSelection'

export type ReportsDisplayOption = 'shouldShowVat'

export type DisplayFilters = Partial<Record<ReportsDisplayOption, boolean>>
export type PeriodFilters = Partial<Record<'period', string>>
export type DateSelectionFilters = Partial<Record<'dateSelection', SalesReportDateSelection>>

export type SalesReportFilters = PeriodFilters & DisplayFilters & DateSelectionFilters

type UseSalesReportFiltersResponse = [SalesReportFilters, (filters: Partial<SalesReportFilters>) => void]

export const defaultQuery: SalesReportFilters = {
  dateSelection: SalesReportDateSelection.Issue,
  period: undefined,
  shouldShowVat: true,
}

export const useSalesReportFilters = (): UseSalesReportFiltersResponse => {
  const { organization } = useUserOrganization()
  const { fiscalYear: globalFiscalYear } = useGlobalFiscalYear()
  const [queryParams, setQueryParams] = useQueryParams<SalesReportFilters>({
    defaultQuery: {
      dateSelection: defaultQuery.dateSelection,
      shouldShowVat: defaultQuery.shouldShowVat,
      ...(globalFiscalYear && organization?.id
        ? { period: encodePeriodValue(getPeriodValueFromFiscalYear(globalFiscalYear), organization.id) }
        : {}),
    },
  })

  return useMemo(
    () => [
      {
        ...queryParams,
        dateSelection:
          queryParams.dateSelection === SalesReportDateSelection.Payment
            ? SalesReportDateSelection.Payment
            : SalesReportDateSelection.Issue,
        // Sometimes `shouldShowVat` comes as a string. It needs to be always `boolean` type.
        shouldShowVat: String(queryParams.shouldShowVat) === 'true',
      },
      setQueryParams,
    ],
    [queryParams, setQueryParams],
  )
}
